import { useLogoutMutation } from '../../store/authentication/authentication.actions';
import { useAppDispatch } from '../../store';
import { clearAuth } from '../../store/authentication/authentication.slice';

export const useLogout = () => {
  const [logoutMutation] = useLogoutMutation();
  const dispatch = useAppDispatch();

  const logout = () => {
    logoutMutation({ clearDeviceData: false });
  };

  const logoutAndSwitchUser = () => {
    logoutMutation({ clearDeviceData: true });
  };

  const clearLocalAuth = (clearDeviceData = false) => {
    dispatch(clearAuth({ clearDeviceData }));
  };

  return {
    logout,
    logoutAndSwitchUser,
    clearLocalAuth
  };
}; 